module.exports = __webpack_public_path__ + "static/media/gladiator-flat-flip.e099f125.jpg";